import Axios from 'axios';
import { cloudFunctions } from '../config';

export default {
  name: 'stripe-helper',

  data() {
    return {
      promoCodeInput: '',
      promoCode: undefined,
      promoCodeChecking: false,
    };
  },

  computed: {
    showPromoCodeButton() {
      return this.promoCodeInput.length > 0 && !this.promoCodeChecking;
    },

    promoCodeIcon() {
      if (this.promoCodeInput.length > 0 && !this.promoCodeChecking) {
        return '';
      }

      if (this.promoCodeChecking) {
        return 'cached';
      }

      return '';
    },
  },

  methods: {
    async createCustomer(data) {
      const result = await Axios({
        method: 'post',
        url: `${cloudFunctions}/stripeCreateCustomer`,
        headers: {
          'content-type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
        data,
      });

      return result.data.customer.id;
    },

    async checkPromoCode(code) {
      const result = await Axios({
        method: 'post',
        url: `${cloudFunctions}/stripeCheckPromoCode`,
        headers: {
          'content-type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
        data: {
          code,
        },
      });

      return result.data.codeData;
    },
    getRestSeisonTime() {
      const saisonEndMonth = 6;
      const currentMonth = new Date().getMonth() + 1;
      const restTimeInMonths =
        currentMonth > saisonEndMonth
          ? 12 - currentMonth + 1 + saisonEndMonth
          : saisonEndMonth - currentMonth + 1;
      return restTimeInMonths;
    },

    getRestPrice(plan) {
      let restPrice;

      if (plan.type === 'monthly') {
        restPrice = (plan.value / 100).toFixed(2);
      } else {
        const restTimeInMonths = this.getRestSeisonTime();
        restPrice = (plan.value * restTimeInMonths) / 12 / 100;
      }

      if (this.promoCode && this.promoCode.coupon) {
        restPrice = (restPrice * (100 - this.promoCode.coupon.percent_off)) / 100;
      }
      return restPrice.toFixed(2);
    },

    async checkCode() {
      if (!this.promoCodeInput) return;

      this.promoCodeChecking = true;
      const code = await this.checkPromoCode(this.promoCodeInput);
      this.promoCodeChecking = false;

      if (code.data.length && code.data[0].active) {
        [this.promoCode] = code.data;
      } else {
        this.promoCode = null;
      }

      console.log({ code });
    },
    scroll(direction, container) {
      let scrollAmount = 0;
      const step = 10;
      const distance = 150;
      const speed = 15;

      const slideTimer = setInterval(() => {
        if (direction === 'left') {
          this.$refs[container].scrollLeft -= step;
        } else {
          this.$refs[container].scrollLeft += step;
        }
        scrollAmount += step;
        if (scrollAmount >= distance) {
          window.clearInterval(slideTimer);
        }
      }, speed);
    },
  },
};
